<template>
  <div :key="refresh_key">
    <!-- *** IME **** -->
    <form-input
      :label="$t('forms.person.institution.inst_name')"
      id="naziv"
      ref="nazivInst"
      required="required"
      :base="institucija.naziv"
      :invalid="invalid_elements.naziv"
    ></form-input>
    <!-- *** Prezime **** -->
    <!-- OIB -->
    <form-input :label="$t('forms.person.phys_pers.oib')" id="oib" ref="OIB" :base="institucija.oib"></form-input>
    <!-- single autocomplete za nadlezno tijelo -->

    <!-- *** Email *** -->
    <form-input-multiple :base="institucija.email_list" ref="email" :name="'email'" :label="$t('forms.person.phys_pers.email_lbl')" :placeholder="$t('forms.person.phys_pers.email_plh')" />
    <!-- *** Broj telefona *** -->
    <form-input-multiple :base="institucija.tel_br_list" ref="telefon" :name="'telefon'" :label="$t('forms.person.phys_pers.tel_lbl')" :placeholder="$t('forms.person.phys_pers.tel_plh')" />
    <!-- *** Web stranica *** -->
    <form-input-multiple :base="institucija.web_list" ref="stranica" :name="'stranica'" :label="$t('forms.person.phys_pers.web_lbl')" :placeholder="$t('forms.person.phys_pers.web_plh')" />

    
  <div class="form-divider"></div>
    <adresa-element ref="adresaElement" :base="institucija.adrese_list" />
    <div class="form-divider"></div>
    
    <!-- *** Drugi kontakt ****
    <form-input
      label="Drugi kontakt"
      id="drugi-kontakt"
      ref="drugiKontakt"
    ></form-input> -->
    <!-- *** Radno vrijeme **** -->
    <form-input
      :label="$t('forms.person.phys_pers.radno_lbl')"
      id="radno-vrijeme"
      ref="radnoVrijeme"
      :base="institucija.radno_vrijeme"
    ></form-input>
    <!-- *** OPIS **** -->
    <form-textarea :label="$t('forms.person.phys_pers.opis_lbl')" id="opis" ref="opis" :base="institucija.opis"></form-textarea>
  </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import adresaElement from "@/components/formElements/adresaElement.vue";
import formInputMultiple from '@/components/formElements/formInputMultiple.vue'
import institutions from "@/apiCallers/promise_handler_db/institucije";


export default {
  data() {
    return {
      refresh_key: 1,
      institucija: {
        naziv: "",
        oib:"",
        email_list: [],
        tel_br_list: [],
        adrese_list: [],
        web_list: [],
        radno_vrijeme: "",
        opis: "",
        rodjendan: "",
      },
    };
  },
  async created() {
    let route_name = this.$router.history.current.name;
    if (route_name === "InstitutionEdit") {
      console.log(this.$router.history.current.params.oib);
      await institutions
        .getSingleInstitucija(this.$router.history.current.params.oib)
        .then(async (resp) => {
          console.log(resp)
          const institucija_entry =resp.data;
          this.$refs.nazivInst.$data.value = institucija_entry.naziv == null ? '':institucija_entry.naziv;
          this.$refs.adresaElement.$data.lista_adresa = institucija_entry.adresa == null ? [] : institucija_entry.adresa;
          this.$refs.OIB.$data.value = institucija_entry.oib == null ? '':institucija_entry.oib
          this.$refs.email.$data.values = institucija_entry.email_list
          this.$refs.telefon.$data.values = institucija_entry.tel_br_list;
          this.$refs.stranica.$data.values = institucija_entry.web_list;
          this.$refs.radnoVrijeme.$data.value = institucija_entry.radno_vrijeme == null ? '': institucija_entry.radno_vrijeme;
          this.$refs.opis.$data.value = institucija_entry.opis == null ? '' : institucija_entry.opis;
          this.$emit("finished");
        });
    }
  },
  mounted() {
    this.institucija.naziv = this.$refs.nazivInst.$data;
    this.institucija.oib = this.$refs.OIB.$data;

    this.institucija.adrese_list = this.$refs.adresaElement.$data;

    this.institucija.email_list = this.$refs.email.$data;
    this.institucija.tel_br_list = this.$refs.telefon.$data;
    this.institucija.web_list = this.$refs.stranica.$data;

    this.institucija.radno_vrijeme = this.$refs.radnoVrijeme.$data;
    this.institucija.opis = this.$refs.opis.$data;
  },
  props: ["industrija", "tipovi_izvora", "izvori","invalid_elements"],
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    "adresa-element":adresaElement,
    "form-input-multiple":formInputMultiple,
  },
};
</script>
